import { RollForwardActivity } from "PFApp/components/rollforward/roll_forward_activity";
import { Inline } from "PFComponents/containers";
import { Divider } from "PFComponents/divider";
import { RollforwardReference } from "PFCore/types";
import { Fragment } from "react";

import css from "./rollforward_info_section.module.scss";

type RollforwardActivitiesProps = {
  activities: RollforwardReference[];
  mode?: "button" | "link";
  onActivityClick?: (activity: RollforwardReference) => void;
};

export const RollforwardActivities = ({ activities, mode, onActivityClick }: RollforwardActivitiesProps) => (
  <Inline alignItems="center">
    {activities.map((activity, index) => (
      <Fragment key={activity.id}>
        <RollForwardActivity
          rollForwardReference={activity}
          mode={mode}
          onClick={onActivityClick ? () => onActivityClick(activity) : undefined}
        />
        {index < activities.length - 1 && <Divider type="vertical" className={css.divider} />}
      </Fragment>
    ))}
  </Inline>
);
